import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Log, MemberNotificationSetting } from 'src/models';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class LogsService extends RestApiService {

  private _urlLogs = '/logs';
  private _urlMemberNotificationsSettings = '/member-notification-settings';
  private _urlNotifyWarranty = '/notify-warranty';
  private _environmentEndpoint = environment.endpoint();

  constructor(public http: HttpClient) {
    super(http);
  }

  getLogs(offSet?: number, limit?: number) {
    let url = this._urlLogs;
    if (offSet >= 0 && limit >= 0) {
      url += `?offset=${offSet}&limit=${limit}`;
    }

    return this.get(url, Log);
  }

  getLogsGroup(leng?: number, startDate?: Date, endDate?: Date) {
    let url = this._urlLogs;
    let startISO = startDate ? `startDate=${startDate.toISOString()}&` : '';
    let endISO = endDate ? `endDate=${endDate.toISOString()}&` : '';
    let len = leng ? `length=${leng}&` : '';
    url += `?${startISO}${endISO}${len}group=true`;
    return this.get(url, Log);
  }

  getMemberNotificationsSetting() {
    const url = this._urlMemberNotificationsSettings;
    return this.get(url, MemberNotificationSetting);
  }

  putMemberNotificationsSetting(data: MemberNotificationSetting) {
    const url = this._urlMemberNotificationsSettings;
    return this.put(url, data, MemberNotificationSetting);
  }

  // Dispara o notifyWarranty do cron diário para um workspace específico.
  // Bypassa a janela do frequencyInDays e envia para todos os managers do
  // workspace. Usado pelo botão de teste em Configurações.
  triggerWarrantyEmail(workspaceId: string) {
    const url = this._environmentEndpoint + this._urlNotifyWarranty;
    return this.http.post(url, { workspaceId });
  }
}
